import { IKeyValueContext } from '@core/models/common.model';

const normalize = (value: string | undefined | null): string => (value ?? '').trim().toLowerCase();

export const toPascalCase = (value: string): string => {
  return value
    .replace(/(\w)(\w*)/g, (_, firstChar: string, rest: string) => firstChar.toUpperCase() + rest.toLowerCase())
    .replace(/\s+/g, '');
};

export const getContextValueByKey = (source: IKeyValueContext[], key: string): string => {
  const lookup = normalize(key);
  const match = source.find((item) => {
    return normalize(item.key) === lookup || normalize(item.value) === lookup || normalize(item.id) === lookup;
  });

  return toPascalCase(match?.value || '-');
};

export const getContextByContext = (source: IKeyValueContext[], context: string): IKeyValueContext[] => {
  return source.filter((item) => item.context === context && item.isActive !== false);
};
